import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'content-moment-caption',
  name: '动态说明与发布主体',
  icon: '说',
  group: '动态详情页',
  description: '展示动态说明、发布主体、发布时间和话题信息。',
  defaultProps: {
    captionPlacement: 'BELOW_MEDIA',
    showPublisher: true,
    showPublishedAt: true,
    showTopics: true
  }
}
